namespace Matrix {
    export enum SupportedLanguage {
        csharp = 1,
        javascript = 2,
        typescript = 3,
        sql = 4
    }
    Serenity.Decorators.registerEnumType(SupportedLanguage, 'Matrix.SupportedLanguage');
}
